import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { RoutesModel, waypoint, currentState } from './routes-model';

@Injectable()
export class RoutesDataService {
    routes:RoutesModel[]=[];
    
    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    route1:RoutesModel;
    route2:RoutesModel;
    route3:RoutesModel;
    route4:RoutesModel;
    route5:RoutesModel;
    route6:RoutesModel;
    route7:RoutesModel;
    route8:RoutesModel;
    route9:RoutesModel;
    route10:RoutesModel;
    waypoint_M10={
        location:'M10, Overport, Berea, South Africa',
        stopover:false
    }

    constructor(private http: HttpClient)
    {
        this.route1= new RoutesModel(0,'CITY','Ntuzuma F','City','750','Ntuzuma, Ntuzuma, 4359','FNB Bank ATM Workshop, 99 Aliwal Street, Durban City, Durban, 4000',26);
        this.route1.state.traffic=true;
        this.route1.state.delay=5;

        this.route2= new RoutesModel(1,'NTUZUMA F','City','Ntuzuma F','750','FNB Bank ATM Workshop, 99 Aliwal Street, Durban City, Durban, 4000','Ntuzuma F, Ntuzuma, 4359',26);
        this.route3= new RoutesModel(2,'CITY','Ntuzuma E','City','750','Ntuzuma E, Ntuzuma, 4032','FNB Bank ATM Workshop, 99 Aliwal Street, Durban City, Durban, 4000',31.9);
        this.route4= new RoutesModel(3,'NTUZUMA E','City','Ntuzuma E','750','FNB Bank ATM Workshop, 99 Aliwal Street, Durban City, Durban, 4000','Ntuzuma E, Ntuzuma, 4032',31.9);
        this.route5= new RoutesModel(4,'CITY','Newlands East','City','817','Newlands East','FNB Bank ATM Workshop, 99 Aliwal Street, Durban City, Durban, 4000',16);
        this.route5.waypoints.push(this.waypoint_M10);
        this.route6= new RoutesModel(5,'Newlands East','City','Newlands East','817','FNB Bank ATM Workshop, 99 Aliwal Street, Durban City, Durban, 4000','Newlands East',16);
        this.route6.waypoints.push(this.waypoint_M10);
        this.route7= new RoutesModel(6,'CITY','Newlands East','City','815','Newlands East','FNB Bank ATM Workshop, 99 Aliwal Street, Durban City, Durban, 4000',18);
        this.route8= new RoutesModel(5,'Newlands East','City','Newlands East','815','FNB Bank ATM Workshop, 99 Aliwal Street, Durban City, Durban, 4000','Newlands East',18);
        this.route9= new RoutesModel(8,'CITY','Ntuzuma','City','750','Ntuzuma F, Ntuzuma, 4359','FNB Bank ATM Workshop, 99 Aliwal Street, Durban City, Durban, 4000',10);
        this.route10= new RoutesModel(9,'NTUZUMA F','City','Ntuzuma','750','FNB Bank ATM Workshop, 99 Aliwal Street, Durban City, Durban, 4000','Ntuzuma F, Ntuzuma, 4359',10);
        this.routes.push(this.route1);
        this.routes.push(this.route2);
        this.routes.push(this.route3);
        this.routes.push(this.route4);
        this.routes.push(this.route5);
        this.routes.push(this.route6);
        this.routes.push(this.route7);
        this.routes.push(this.route8);
        this.routes.push(this.route9);
        this.routes.push(this.route10);
    }

    getRoutes() {
        return this.http.get('/routes');
    }

    createRoute(data) {
        let body = JSON.stringify(data);
        return this.http.post('/routes/', body, this.httpOptions);
    }

    updateRoute(data) {
        let body = JSON.stringify(data);
        return this.http.put('/routes/' + data.id, body, this.httpOptions);
    }

    deleteRoute(data) {
        return this.http.delete('/routes/' + data.id);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/routes-data/routes-data.service.ts